import React, { FunctionComponent } from "react";
import { IconButton, MuiThemeProvider, Table, Tooltip } from "@material-ui/core";
import PrintIcon from '@material-ui/icons/Print';
import { useStore } from "../../../store";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../useTableStyle";
import { useItemReturnStyles } from "../useItemReturnStyles";
import { ThemeProvider } from "@mui/material/styles";

type DivisiontProps = {
  voucherData: Array<any>;
  getPrintDetails: (returnId: number) => void;
  searchFlag: boolean;
};

export const ItemReturnVoucherList: FunctionComponent<DivisiontProps> = ({
  voucherData,
  getPrintDetails,
  searchFlag
}) => {
  const classes = useItemReturnStyles();
  const getMuiTheme = useTableStyles();
  const [reasons] = useStore("reasons");

  const columns = [
    "Item Name",
    "Item Number",
    "Reason",
    "Quantity",
    "Price",
    "Type"
  ];

  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    search: true,
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: false,
      yAxis: true,
    },

    isRowSelectable: function () {
      return false;
    },

    /* print button visibility according to current day */
    customToolbar: () => <Tooltip title={"Print"}>
      {searchFlag ? <div></div> : (
        <IconButton onClick={() => {
          getPrintDetails(voucherData[0].itemreturn_id)
        }}>
          <PrintIcon color="secondary"/>
        </IconButton>
      )}
    </Tooltip>
  };

  return (
    <Table className={classes.table}>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          title={"Item Return Voucher Details"}
          columns={columns}
          data={voucherData.map((row: any) => {
            return [
              row.itemname,
              row.plucode,
              reasons && reasons.find(
                (reason: any) =>
                  reason.reason_id === row.reasonid
              ).reason_description,
              parseInt(row.quantity).toFixed(3),
              row.unit_price,
              row.retitemuomtype === null ? "NIL" : row.retitemuomtype
            ];
          })}
          options={options}
        />
      </ThemeProvider>
    </Table>
  );
};